'use client';

import { useEffect, useState } from 'react';
import Utils from '../utils/utils';

// -----------------------------------------------------------------------------
export const useOS = (): string => {
  const [os, setOs] = useState<string>('');

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    setOs(Utils.getOS());
  }, []);

  return os;
};

